<template>
  <!-- eslint-disable max-len -->
  <img
      id="header__logo"
      class="edgefirst-logo"
      src="../assets/img/logo-white.svg"
      @click="gotoHome()"
    />

  <template v-if="isMobile">
    <v-layout id="navigation-bar" class="header mobile-header">
      <div id="header__left" class="left ms-3">
  

      <div style="width:100px;height: 60px;"/>
      
      <button class="button link-button" @click="router.go(-1)">← Back</button>
      <button  class="button link-button" @click="router.push({ path: '/projects' });">Projects</button>
        
        <!-- <div id="header-module" class="header__module _mobile">
          <slot name="header-slot" />
        </div> -->
      </div>
      <div id="header__center" class="center">
        <!-- <div id="header-project" class="header__breadcrumbs">
        <slot name="page-slot" />
      </div> -->
        <div id="header-extra" class="header__extra">
          <slot name="extra-slot" />
        </div>
      </div>

        <IconButton
          v-if="userInfo"
          :icon="'menu'"
          :width="24"
          :height="24"
          :type="''"
          class="drawer-icon"
          @click="drawer = !drawer"
        />

      <!-- <div id="navigation-bar__menus" class="menus">
      <UserMenu />
    </div> -->
      <v-navigation-drawer
        v-if="userInfo"
        v-model="drawer"
        app
        temporary
      >
        <div class="mobile-drawer">
          <v-list class="mobile-drawer__list">
            <div class="mobile-user-header">
              <UserIcon
                v-if="userInfo"
                class="mt-1"
                :user="userInfo"
                :size="'48px'"
              />
              <span class="mobile-user-header__username">{{ userInfo?.username }}</span>
            </div>
            <div class="mobile-drawer__hr" />

            <ul id="user-menu" class="user-menu">
              <li v-if="isSuper">
                <BaseMenuButton @click="closeDrawer(), $router.push({ path: '/super' })">
                  <SVGIcon
                    :width="'24px'"
                    :height="'24px'"
                    :iconName="'admin'"
                  />
                  <span>Super Admin</span>
                </BaseMenuButton>
              </li>
              <li v-if="isSuper || isAdmin">
                <BaseMenuButton @click="closeDrawer(), $router.push({ path: '/admin' })">
                  <SVGIcon
                    :width="'24px'"
                    :height="'24px'"
                    :iconName="'verified'"
                  />
                  <span>Admin Console</span>
                </BaseMenuButton>
              </li>
              <li>
                <BaseMenuButton @click="closeDrawer(), $router.push({ path: '/user' })">
                  <SVGIcon
                    :width="'24px'"
                    :height="'24px'"
                    :iconName="'account_circle'"
                  />
                  <span>Profile</span>
                </BaseMenuButton>
              </li>
            </ul>

            <div class="mobile-drawer__hr" />

            <ul id="module-menu" class="module-menu">
              <li>
                <BaseMenuButton
                  id="module-menu__projects"
                  @click="gotoPageName('projects'); closeDrawer()"
                >
                  <div class="li-row">
                    <SVGIcon width="28px" height="28px" iconName="folder2" />
                    <div class="li-text">
                      <div class="li-text__title">Projects</div>
                      <div class="li-text__description">Manage projects</div>
                    </div>
                  </div>
                </BaseMenuButton>
              </li>
              <li>
                <BaseMenuButton
                  id="module-menu__datasets"
                  :disabled="!currentProject"
                  @click="gotoPageName('datasets'); closeDrawer()"
                >
                  <div class="li-row">
                    <SVGIcon width="28px" height="28px" iconName="database2" />
                    <div class="li-text">
                      <div class="li-text__title">Datasets</div>
                      <div class="li-text__description">Curate, upload, and share datasets</div>
                    </div>
                  </div>
                </BaseMenuButton>
              </li>
              <li>
                <BaseMenuButton
                  id="module-menu__edit-audit-annotations"
                  :disabled="!currentProject"
                  @click="gotoPageName('taskboard'); closeDrawer()"
                >
                  <div class="li-row">
                    <SVGIcon width="28px" height="28px" iconName="tag" />
                    <div class="li-text">
                      <div class="li-text__title">Auditing Tasks</div>
                      <div class="li-text__description">Manage labelling, audit, and more</div>
                    </div>
                  </div>
                </BaseMenuButton>
              </li>
              <li>
                <BaseMenuButton
                  id="module-menu__trainer"
                  :disabled="!currentProject"
                  @click="gotoPageName('experiment'); closeDrawer()"
                >
                  <div class="li-row">
                    <SVGIcon width="28px" height="28px" iconName="science" />
                    <div class="li-text">
                      <div class="li-text__title">Model Experiments</div>
                      <div class="li-text__description">Train and validate models</div>
                    </div>
                  </div>
                </BaseMenuButton>
              </li>
              <li>
                <BaseMenuButton
                  id="module-menu__cloud-instances"
                  @click="gotoPageName('servers'); closeDrawer()"
                >
                  <div class="li-row">
                    <SVGIcon width="28px" height="28px" iconName="cloud_servers" />
                    <div class="li-text">
                      <div class="li-text__title">Cloud Instances</div>
                      <div class="li-text__description">Manage virtual servers</div>
                    </div>
                  </div>
                </BaseMenuButton>
              </li>
              <li>
                <BaseMenuButton
                  id="module-menu__snapshots"
                  @click="gotoPageName('snapshots'); closeDrawer()"
                >
                  <div class="li-row">
                    <SVGIcon width="28px" height="28px" iconName="database_sync" />
                    <div class="li-text">
                      <div class="li-text__title">Data Snapshots</div>
                      <div class="li-text__description">Save and restore data</div>
                    </div>
                  </div>
                </BaseMenuButton>
              </li>
            </ul>

            <div class="mobile-drawer__hr" />

            <ul id="help-menu" class="help-menu">
              <li>
                <HelpButton helpstyle="menu" />
              </li>
              <li>
                <BaseMenuButton :id="'help-menu__feedback'" @click="closeDrawer(), openFeedbackModal()">
                  <SVGIcon
                    :width="'24px'"
                    :height="'24px'"
                    :iconName="'feedback'"
                  />
                  <span>
                    Feedback
                  </span>
                </BaseMenuButton>
              </li>
              <li>
                <BaseMenuButton :id="'help-menu__release-notes'" @click="closeDrawer(), window.open('https://doc.edgefirst.ai/latest/release-notes/', '_blank')">
                  <SVGIcon
                    :width="'24px'"
                    :height="'24px'"
                    :iconName="'description'"
                  />
                  <span>
                    Release Notes
                  </span>
                </BaseMenuButton>
              </li>
               <li>
                <BaseMenuButton :id="'help-menu__apis'" @click="openApiDocs">
                  <SVGIcon
                    :width="'24px'"
                    :height="'24px'"
                    :iconName="'description'"
                  />
                  <span>
                    APIs
                  </span>
                </BaseMenuButton>
              </li>
            </ul>

            <div v-if="allowDebug === 'yes'" class="mobile-drawer__hr" />

            <ul id="debug-menu" class="debug-menu">
              <li v-if="allowDebug === 'yes'">
                <BaseMenuButton>
                  <SVGIcon
                    :width="'24px'"
                    :height="'24px'"
                    :iconName="'debug'"
                  />
                  <span>Debug</span>
                  <BaseSwitch v-model:active="debugModeActive" />
                </BaseMenuButton>
              </li>
            </ul>

            <div class="mobile-drawer__hr" />

            <ul id="logout-menu" class="logout-menu">
              <li>
                <BaseMenuButton @click="logOut">
                  <SVGIcon
                    :width="'24px'"
                    :height="'24px'"
                    :iconName="'logout'"
                  />
                  <span>Log Out</span>
                </BaseMenuButton>
              </li>
            </ul>
          </v-list>
          <div class="mobile-drawer__footer">
            <span class="version-text">Version: {{ version }} - {{ frontendVersion }}</span>
          </div>
        </div>
      </v-navigation-drawer>
      <FeedbackModal ref="feedbackModal" />
    </v-layout>
    <div id="header-module" class="header__module _mobile">
      <slot name="header-slot" />
    </div>
  </template>

<!--  =========================== desktop ================================== -->

  <div v-else id="navigation-bar" class="header">
    
    <img
        id="header__logo"
        class="edgefirst-logo"
        src="../assets/img/logo-white.svg"
        @click="gotoHome()"
      >

      <div style="width:100px;"/>

      <button class="button link-button" @click="router.go(-1)">Back</button>
      <button  class="button link-button" @click="router.push({ path: '/projects' });">Projects</button>

    
    <div id="header__left" class="left">
      <div id="header-module" class="header__module">
        <slot name="header-slot" />
      </div>
    </div>
    <div id="header__center" class="center">
      <div id="header-project" class="header__breadcrumbs">
        <slot name="page-slot" />
      </div>
      <div id="header-extra" class="header__extra">
        <slot name="extra-slot" />
      </div>
    </div>
    <div v-if="showMenus" id="navigation-bar__menus" class="menus">
      <WarningMenu />
      <div />

      <div class="credits">
        <span v-if="credits">USD {{ dollars }}</span>
        <button id="header-request-funds-btn" class="button button-sm button-rounded" @click="openRequestFundsModal">Add Funds</button>
      </div>

      <div />
      <HelpButton :url="helpURL" />
      <div />
      <ModuleMenu />
      <div />
      <HelpMenu />
      <div />
      <UserMenu />
    </div>
  </div>
</template>

<script setup>
import {
  ref, computed, watch, onMounted,
} from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { auzone_logo } from "@/assets/js/icons";
import { useMobile } from '@/composables/useMobile';
import { encodeID } from '@/assets/js/utils.js';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';

import UserMenu from "@/components/UserMenu.vue";
import HelpMenu from "@/components/HelpMenu.vue";
import ModuleMenu from "@/components/ModuleMenuV2.vue";
import WarningMenu from "@/components/WarningMenu.vue";
import HelpButton from "@/components/HelpButton.vue";
import IconButton from '@/components/IconButton.vue';
import UserIcon from '@/components/UserIcon.vue';
import SVGIcon from '@/components/SVGIcon.vue';
import BaseMenuButton from '@/components/BaseMenuButton.vue';
import FeedbackModal from '@/components/FeedbackModal.vue';

import BaseSwitch from '@/components/BaseSwitch.vue';

const props = defineProps({
  headerTitle: { type: String, default: 'Welcome' },
  page: { type: String, default: '' },
  helpURL: { type: String, default: '' },
  showMenus: { type: Boolean, default: true },
});

const store = useStore();
const router = useRouter();

const auzone_logo_ref = ref(auzone_logo);
const show_menu = ref(false);
const debugMode = ref(false);
const { isMobile } = useMobile();
const drawer = ref(false);
const feedbackModal = ref(null);
const debugModeActive = ref(false);

const currentProject = computed(() => store.state.projects.currentProject);
const isDebugMode = computed(() => store.state.debugMode);
const userInfo = computed(() => store.state.user.user);
const debugModeStoreState = computed(() => store.state.debugMode);
const allowDebug = computed(() => store.state.appVersion.allowDebug);
const isSuper = computed(() => userInfo.value?.role === 'super');
const isAdmin = computed(() => userInfo.value?.role === 'admin');
const version = computed(() => store.state.appVersion.version);
const frontendVersion = computed(() => store.state.appVersion.frontendVersion);

const isFetchingUsageSummary = ref(false);
const credits = ref(null);
const dollars = computed(() => Number(credits.value).toLocaleString(navigator.language || 'en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
const requestFundsModal = ref(null);
const showRequestModal = ref(false);

// Methods
function gotoHome() {
  if (userInfo.value) {
    router.push({ name: 'dashboard' });
  } else {
    router.push({ name: 'landing' });
  }
}


function  openApiDocs() {
      window.open(window.location.origin + '/api');
    }

function gotoPageName(name) {
  if (name === 'datasets') {
    router.push({ name, params: { projectId: encodeID(currentProject.value?.id, 'p') || undefined } });
  } else if (name === 'experiments') {
    router.push({ name, params: { projectId: Number(currentProject.value?.id).toString(16) || undefined } });
  } else {
    router.push({ name, params: { projectId: currentProject.value?.id || undefined } });
  }
}

function logOut() {
  router.push({ path: '/logout' });
}

function closeDrawer() {
  drawer.value = false;
}

function open(page) {
  window.open(page);
}

function openFeedbackModal() {
  feedbackModal.value.showModal();
}

function openRequestFundsModal() {
  router.push({ path: '/admin/topup' });

  // MUID showRequestModal.value = true;
}

onMounted(() => {
  if (debugModeStoreState.value) {
    debugModeActive.value = debugModeStoreState.value;
  }

  if (props.showMenus) {
    getUsagePercentage();
  }
});

// Watchers
watch(debugMode, (newVal) => {
  store.commit('setDebugMode', !store.state.debugMode);
});

watch(debugModeActive, () => {
  store.commit('setDebugMode', debugModeActive.value);
});

async function getUsagePercentage() {
  isFetchingUsageSummary.value = true;
  const dataconnect = new DatastoreConnect();
  const orgId = store.state.user?.user?.organization_id;
  await dataconnect.getUsageSummaryForOrganization({ organization_id: orgId })
    .then((resp) => {
      if (resp.result) {
        credits.value = resp.result.total_funds_and_credits;
      } else if (!resp || resp.error) {
        console.error(`Error getting usage summary`);
        // $toast.open({
        //   queue: true,
        //   duration: 5000,
        //   message: `Error getting usage summary`,
        //   type: "error",
        //   position: "top",
        // });
      }
      isFetchingUsageSummary.value = false;
    })
    .catch((e) => {
      isFetchingUsageSummary.value = false;
    });
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.header {
  display: flex;
  font-size: 1.5rem;
  gap: 15px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.5), 0 1px 8px rgba(0,0,0,0.375);
  z-index: 10;
  background: var(--header-background);
  color: var(--header-text-color);
  margin-bottom: 20px;

  .left {
    display: flex;
    min-width: fit-content;
    justify-content: flex-start;
    align-items: center;
    overflow-x: hidden;
    overflow-y: hidden;
  }

  .center {
    display: flex;
    flex: 1 1 0px;
    align-items: center;
    min-width: 0;
    overflow: hidden;
  }

  .menus {
    display: flex;
    min-width: fit-content;
    justify-content: flex-end;
    align-items: center;
    overflow-x: hidden;
    overflow-y: hidden;

    div {
      margin: 0px 10px;
    }
  }

  &__module {
    font-weight: 500;
    letter-spacing: 0.0325em;
  }

  &__breadcrumbs {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: min-content;
    height: 70%;
    max-width: 100%;
    line-height: 1;

    &:not(:empty) {
      flex-grow: 1;
    }
  }

  &__extra {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: min-content;
    height: 100%;
    max-width: 100%;

    &:not(:empty) {
      flex-grow: 1;
    }
  }

  &__logo {
    width: 100px;
    min-width: 70px;
    height: 50px;
    padding: 6px 6px 6px 6px;
    cursor: pointer;
  }


  &__select-theme {
    position: relative;
    width: 150px;
    height: 30px;
  }

  &__button {
    padding-right: 10px;
  }

  &__dot-menu {
    display: flex;
    flex: 0 0 auto;
    height: 100%;
    align-items: center;
    justify-content: center;
    padding: 0 4px;
    background: none;
    border: none;
    cursor: pointer;
    color: var(--header-dot-menu);

    &:hover {
      background: var(--header-button-background-hover);
      color: var(--header-button-color-hover);
    }

    &._active {
      background: var(--header-button-background-hover);
      color: var(--header-button-color-hover);
    }
  }

  &__user {
    display: flex;
    flex: 0 0 auto;
    width: 32px;
    height: 32px;
    cursor: pointer;
    border-radius: 50%;
    background: rgb(5, 60, 143);
    margin-right: 8px;
    justify-content: center;
    align-items: center;
  }

  &__user-letter {
    height: min-content;
    font-size: 1.25rem;
  }
}


.edgefirst-logo {
    height: 80px;
    position: absolute;
    left: 0;  
    z-index: 11;
    
    padding: 6px 6px 6px 6px;
   
  }

.header.switch-label {
  font-size: 20px;
}

.mobile-header {
  max-height: 50px;
}

.drawer-icon {
  margin: auto 16px auto auto;
}
.mobile-drawer {
  display: flex;
  flex-direction: column;
  overflow: auto;

  &__list {
    display: flex;
    flex-direction: column;
  }

  &__hr {
    width: 100%;
    border-top: 1px solid;
    border-color: rgb(212, 219, 226);
    margin-top: 8px;
    margin-bottom: 4px;
  }
}

.mobile-user-header {
  display: flex;
  flex-direction: column;
  margin: 0 10px 0 0;
  align-self: flex-end;
  align-items: center;

  &__username {
    font-size: 1rem;
    font-weight: 600;
  }
}

.module-menu, .help-menu, .user-menu, .debug-menu, .logout-menu {
  list-style: none;

  li {
    padding: 0 1rem;
  }
}

.debug-menu:deep {
  .switch {
    margin-left: auto;
  }
}

.li-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.li-text {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  &__title{
    display: flex;
    font-size: 1rem;
    font-weight: 600;
    margin-left: 12px;
  }

  &__description{
    display: flex;
    font-size: 0.8rem;
    font-weight: 600;
    margin-left: 12px;
    margin-top: 5px;
    text-align: left;
    color: rgba(61, 60, 60, 0.5);
  }
}

.version-text {
  display: block;
  width: inherit;
  align-items: center;
  padding: 4px 1rem;
  text-align: left;
  font: inherit;
  font-size: 0.7rem;
  font-weight: 600;
  color: rgba(92, 91, 91, 0.5);
  word-wrap: break-word;
}

.credits {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-size: 1rem;

  button {
    height: 32px;
    background-color: var(--color-primary-400);

    &:hover {
      background-color: var(--color-primary-300);
    }
  }
}
</style>
